// Site-wide details used in the footer and on the signature page.
// Change them here and every page picks up the new value.

export const COMPANY_NAME = 'USAtownforms'; // parent company — placeholder until the final name is decided
export const SUPPORT_EMAIL = 'support@matownforms.com';

// Termly-hosted policies (Termly dashboard -> policy -> Publish -> link).
// Leave as null until the link exists: the footer hides the link and the
// signature page shows the name as plain text instead of a dead link.
export const PRIVACY_POLICY_URL = null; // TODO: Termly privacy policy link
export const TERMS_OF_SERVICE_URL = null; // TODO: Termly terms of service link
